<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 7v10a1 1 0 001 1h10a1 1 0 001-1V7a1 1 0 00-1-1H7a1 1 0 00-1 1zm2 1h8v8H8zM3 8.39a1 1 0 001-1V4h3.38a1 1 0 000-2H3a1 1 0 00-1 1v4.39a1 1 0 001 1zM21 2h-4.38a1 1 0 100 2H20v3.38a1 1 0 002 0V3a1 1 0 00-1-1zM7.38 20H4v-3.39a1 1 0 00-2 0V21a1 1 0 001 1h4.38a1 1 0 100-2zM21 15.62a1 1 0 00-1 1V20h-3.38a1 1 0 000 2H21a1 1 0 001-1v-4.38a1 1 0 00-1-1z"/></svg>